import { render, staticRenderFns } from "./create-custom-luts-folder.vue?vue&type=template&id=642b339a&"
import script from "./create-custom-luts-folder.vue?vue&type=script&lang=js&"
export * from "./create-custom-luts-folder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports